{
  "PROFILE_SETTINGS": {
    "LINK": "പ്രൊഫൈൽ ക്രമീകരണങ്ങൾ",
    "TITLE": "പ്രൊഫൈൽ ക്രമീകരണങ്ങൾ",
    "BTN_TEXT": "പ്രൊഫൈൽ അപ്‌ഡേറ്റ് ചെയ്യുക",
    "DELETE_AVATAR": "അവതാർ നീക്കം ചെയ്യുക",
    "AVATAR_DELETE_SUCCESS": "അവതാർ വിജയകരമായി നീക്കം ചെയ്തു",
    "AVATAR_DELETE_FAILED": "അവതാർ ഇല്ലാതാക്കുന്നതിൽ പിഴവ് സംഭവിച്ചു, ദയവായി വീണ്ടും ശ്രമിക്കുക",
    "UPDATE_SUCCESS": "നിങ്ങളുടെ പ്രൊഫൈൽ വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",
    "PASSWORD_UPDATE_SUCCESS": "നിങ്ങളുടെ പാസ്‌വേഡ് വിജയകരമായി മാറ്റി",
    "AFTER_EMAIL_CHANGED": "നിങ്ങളുടെ പ്രൊഫൈൽ വിജയകരമായി അപ്‌ഡേറ്റു ചെയ്തിരിക്കുന്നു, ലോഗിൻ ക്രെഡൻഷ്യലുകൾ മാറ്റിയതിനാൽ ദയവായി വീണ്ടും ലോഗിൻ ചെയ്യുക",
    "FORM": {
      "PICTURE": "പ്രൊഫൈൽ ചിത്രം",
      "AVATAR": "പ്രൊഫൈൽ ചിത്രം",
      "ERROR": "ദയവായി ഫോമിലെ പിശകുകൾ പരിഹരിക്കുക",
      "REMOVE_IMAGE": "നീക്കം ചെയ്യുക",
      "UPLOAD_IMAGE": "ചിത്രം അപ്‌ലോഡു ചെയ്യുക",
      "UPDATE_IMAGE": "ചിത്രം അപ്‌ഡേറ്റു ചെയ്യുക",
      "PROFILE_SECTION": {
        "TITLE": "പ്രൊഫൈൽ",
        "NOTE": "നിങ്ങളുടെ ഇമെയിൽ വിലാസം നിങ്ങളുടെ ഐഡന്റിറ്റിയാണ്, ഒപ്പം ലോഗിൻ ചെയ്യാൻ ഇതാണ്  ഉപയോഗിക്കേണ്ടത്."
      },
      "SEND_MESSAGE": {
        "TITLE": "സന്ദേശങ്ങൾ അയയ്ക്കാനുള്ള ഹോട്ട്‌കീ",
        "NOTE": "നിങ്ങളുടെ എഴുതാനുള്ള ഇഷ്ടാനുസരണം ഹോട്ട്‌കീ (Enter അല്ലെങ്കിൽ Cmd/Ctrl+Enter) തിരഞ്ഞെടുക്കാം.",
        "UPDATE_SUCCESS": "നിങ്ങളുടെ ക്രമീകരണങ്ങൾ വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "എന്റർ (↵)",
            "CONTENT": "അയയ്ക്കൽ ബട്ടൺ ക്ലിക്ക് ചെയ്യാതെ Enter കീ അമർത്തി സന്ദേശങ്ങൾ അയയ്ക്കുക."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "സന്ദേശങ്ങൾ അയയ്ക്കാൻ അയയ്ക്കൽ ബട്ടൺ ക്ലിക്കുചെയ്യുന്നതിന് പകരം Cmd/Ctrl + Enter കീ അമർത്തുക."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "ഇന്റർഫേസ്",
        "NOTE": "നിങ്ങളുടെ Chatwoot ഡാഷ്ബോർഡിന്റെ രൂപവും അനുഭവവും ഇഷ്ടാനുസൃതമാക്കുക.",
        "FONT_SIZE": {
          "TITLE": "ഫോണ്ട് വലിപ്പം",
          "NOTE": "നിങ്ങളുടെ ഇഷ്ടാനുസരണം ഡാഷ്ബോർഡിലെ എഴുത്തിന്റെ വലിപ്പം ക്രമീകരിക്കുക.",
          "UPDATE_SUCCESS": "നിങ്ങളുടെ ഫോണ്ട് ക്രമീകരണങ്ങൾ വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",
          "UPDATE_ERROR": "ഫോണ്ട് ക്രമീകരണങ്ങൾ അപ്ഡേറ്റ് ചെയ്യുമ്പോൾ പിശക് സംഭവിച്ചു, ദയവായി വീണ്ടും ശ്രമിക്കുക",
          "OPTIONS": {
            "SMALLER": "ചെറുതായി",
            "SMALL": "ചെറുത്",
            "DEFAULT": "ഡിഫോൾട്ട്",
            "LARGE": "വലുത്",
            "LARGER": "കൂടുതൽ വലുത്",
            "EXTRA_LARGE": "അധികം വലുത്"
          }
        },
        "LANGUAGE": {
          "TITLE": "പ്രിയപ്പെട്ട ഭാഷ",
          "NOTE": "നിങ്ങൾ ഉപയോഗിക്കാൻ ആഗ്രഹിക്കുന്ന ഭാഷ തിരഞ്ഞെടുക്കുക.",
          "UPDATE_SUCCESS": "നിങ്ങളുടെ ഭാഷാ ക്രമീകരണങ്ങൾ വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",
          "UPDATE_ERROR": "ഭാഷാ ക്രമീകരണങ്ങൾ അപ്ഡേറ്റ് ചെയ്യുമ്പോൾ ഒരു പിശക് സംഭവിച്ചു, ദയവായി വീണ്ടും ശ്രമിക്കുക",
          "USE_ACCOUNT_DEFAULT": "അക്കൗണ്ട് ഡിഫോൾട്ട് ഉപയോഗിക്കുക"
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "വ്യക്തിഗത സന്ദേശ ഒപ്പ്",
        "NOTE": "നിങ്ങൾ അയക്കുന്ന ഓരോ സന്ദേശത്തിന്റെയും അവസാനം പ്രത്യക്ഷപ്പെടുന്ന ഒരു വ്യത്യസ്ത സന്ദേശ ഒപ്പ് സൃഷ്ടിക്കുക. ലൈവ്-ചാറ്റ്, ഇമെയിൽ, API ഇൻബോക്സുകളിൽ പിന്തുണയ്ക്കുന്ന ഒരു ഇൻലൈൻ ചിത്രം ഉൾപ്പെടുത്താനും നിങ്ങൾക്ക് കഴിയും.",
        "BTN_TEXT": "സന്ദേശ ഒപ്പ് സംരക്ഷിക്കുക",
        "API_ERROR": "ഒപ്പ് സംരക്ഷിക്കാൻ കഴിഞ്ഞില്ല! വീണ്ടും ശ്രമിക്കുക",
        "API_SUCCESS": "ഒപ്പ് വിജയകരമായി സംരക്ഷിച്ചു",
        "IMAGE_UPLOAD_ERROR": "ചിത്രം അപ്‌ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല! വീണ്ടും ശ്രമിക്കുക",
        "IMAGE_UPLOAD_SUCCESS": "ചിത്രം വിജയകരമായി ചേർത്തു. സിഗ്നേച്ചർ സേവ് ചെയ്യാൻ ദയവായി സേവ് ക്ലിക്ക് ചെയ്യുക",
        "IMAGE_UPLOAD_SIZE_ERROR": "ചിത്രത്തിന്റെ വലുപ്പം {size}MB-ൽ കുറവായിരിക്കണം",
        "INLINE_IMAGE_WARNING": "Pasted inline images were removed. Please use the image upload button to add images to your signature."
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "സന്ദേശ ഒപ്പ്",
        "ERROR": "സന്ദേശ ഒപ്പ് ശൂന്യമാകരുത്",
        "PLACEHOLDER": "ഇവിടെ നിങ്ങളുടെ വ്യക്തിഗത സന്ദേശ ഒപ്പ് ചേർക്കുക."
      },
      "PASSWORD_SECTION": {
        "TITLE": "പാസ്‌വേഡ്",
        "NOTE": "നിങ്ങളുടെ പാസ്‌വേഡ് അപ്‌ഡേറ്റ് ചെയ്യുന്നത് ഒന്നിലധികം ഉപകരണങ്ങളിൽ നിങ്ങളുടെ ലോഗിനുകൾ പുനഃസജ്ജീകരിക്കും.",
        "BTN_TEXT": "പാസ്‌വേഡ് മാറ്റുക"
      },
      "SECURITY_SECTION": {
        "TITLE": "സുരക്ഷ",
        "NOTE": "നിങ്ങളുടെ അക്കൗണ്ടിനായി അധിക സുരക്ഷാ സവിശേഷതകൾ നിയന്ത്രിക്കുക.",
        "MFA_BUTTON": "രണ്ട് ഘട്ടം സ്ഥിരീകരണം നിയന്ത്രിക്കുക"
      },
      "SESSIONS_SECTION": {
        "TITLE": "Active Sessions",
        "NOTE": "These are the devices currently logged in to your account.",
        "CURRENT": "Current session",
        "REVOKE": "Revoke",
        "REVOKE_SUCCESS": "Session revoked successfully",
        "REVOKE_ERROR": "Unable to revoke session. Please try again.",
        "FETCH_ERROR": "Unable to fetch sessions. Please try again.",
        "LAST_ACTIVE": "Last active",
        "UNKNOWN_DEVICE": "Unknown device"
      },
      "ACCESS_TOKEN": {
        "TITLE": "ആക്സസ് ടോക്കൺ",
        "NOTE": "നിങ്ങൾ ഒരു എപിഐ അടിസ്ഥാനമാക്കിയുള്ള സംയോജനം നിർമ്മിക്കുകയാണെങ്കിൽ ഈ ടോക്കൺ ഉപയോഗിക്കാൻ കഴിയും",
        "PAID_PLAN_NOTE": "API access tokens are available on paid plans.",
        "COPY": "പകർത്തുക",
        "RESET": "പുനഃസജ്ജമാക്കുക",
        "CONFIRM_RESET": "നിങ്ങൾക്ക് ഉറപ്പാണോ?",
        "CONFIRM_HINT": "സ്ഥിരീകരിക്കാൻ വീണ്ടും ക്ലിക്ക് ചെയ്യുക",
        "RESET_SUCCESS": "ആക്‌സസ് ടോക്കൺ വിജയകരമായി പുനഃസൃഷ്ടിച്ചു",
        "RESET_ERROR": "ആക്‌സസ് ടോക്കൺ പുനഃസൃഷ്ടിക്കാൻ കഴിയുന്നില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "ഓഡിയോ അലർട്ടുകൾ",
        "NOTE": "പുതിയ സന്ദേശങ്ങൾക്കും സംഭാഷണങ്ങൾക്കും ഡാഷ്ബോർഡിൽ ഓഡിയോ അലർട്ടുകൾ സജീവമാക്കുക.",
        "PLAY": "ശബ്ദം പ്ലേ ചെയ്യുക",
        "ALERT_TYPES": {
          "NONE": "ഒന്നുമില്ല",
          "MINE": "നിയോഗിച്ചിരിക്കുന്നു",
          "ALL": "എല്ലാം",
          "ASSIGNED": "എനിക്ക് നിയോഗിച്ച സംഭാഷണങ്ങൾ",
          "UNASSIGNED": "നിയോഗിക്കാത്ത സംഭാഷണങ്ങൾ",
          "NOTME": "മറ്റുള്ളവർക്കു നിയോഗിച്ച തുറന്ന സംഭാഷണങ്ങൾ"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "നിങ്ങൾ ഏതെങ്കിലും ഓപ്ഷനുകൾ തിരഞ്ഞെടുക്കാത്തതിനാൽ, നിങ്ങൾക്ക് യാതൊരു ഓഡിയോ അലർട്ടുകളും ലഭിക്കില്ല.",
          "ASSIGNED": "നിങ്ങൾക്ക് നിങ്ങൾക്ക് നിയോഗിച്ച സംഭാഷണങ്ങൾക്ക് അലർട്ടുകൾ ലഭിക്കും.",
          "UNASSIGNED": "നിങ്ങൾക്ക് ഏത് നിയോഗിക്കപ്പെട്ടിട്ടില്ലാത്ത സംഭാഷണങ്ങൾക്കും അലർട്ടുകൾ ലഭിക്കും.",
          "NOTME": "മറ്റുള്ളവർക്ക് നിയോഗിച്ച സംഭാഷണങ്ങൾക്ക് നിങ്ങൾക്ക് അലർട്ടുകൾ ലഭിക്കും.",
          "ASSIGNED+UNASSIGNED": "നിങ്ങൾക്ക് നിങ്ങൾക്ക് നിയോഗിച്ച സംഭാഷണങ്ങൾക്കും ഏത് പരിചരിക്കപ്പെടാത്തവയ്ക്കും അലർട്ടുകൾ ലഭിക്കും.",
          "ASSIGNED+NOTME": "നിങ്ങൾക്ക് നല്കപ്പെട്ടും മറ്റുള്ളവർക്കും നല്കപ്പെട്ട സംഭാഷണങ്ങൾക്ക് അലർട്ടുകൾ ലഭിക്കും, എന്നാൽ നല്കപ്പെടാത്തവയ്ക്ക് ലഭിക്കില്ല.",
          "NOTME+UNASSIGNED": "നിങ്ങൾക്ക് ശ്രദ്ധിക്കപ്പെടാത്ത സംഭാഷണങ്ങൾക്കും മറ്റുള്ളവർക്കു നല്കപ്പെട്ടവയ്ക്കും അലർട്ടുകൾ ലഭിക്കും.",
          "ASSIGNED+NOTME+UNASSIGNED": "എല്ലാ സംഭാഷണങ്ങൾക്കും നിങ്ങൾക്ക് അലർട്ടുകൾ ലഭിക്കും."
        },
        "ALERT_TYPE": {
          "TITLE": "സംഭാഷണങ്ങളുടെ അലർട്ട് ഇവന്റുകൾ",
          "NONE": "ഒന്നുമില്ല",
          "ASSIGNED": "നിയുക്തമായ സംഭാഷണങ്ങൾ",
          "ALL_CONVERSATIONS": "എല്ലാ സംഭാഷണങ്ങളും"
        },
        "DEFAULT_TONE": {
          "TITLE": "അലർട്ട് ടോൺ:"
        },
        "CONDITIONS": {
          "TITLE": "അലർട്ട് നിബന്ധനകൾ:",
          "CONDITION_ONE": "ബ്രൗസർ വിൻഡോ സജീവമല്ലെങ്കിൽ മാത്രമേ ഓഡിയോ അലർട്ടുകൾ അയയ്ക്കൂ",
          "CONDITION_TWO": "എല്ലാ നിയോഗിച്ച സംഭാഷണങ്ങളും വായിച്ചെടുക്കുന്നത് വരെ ഓരോ 30 സെക്കന്റിലും അലർട്ടുകൾ അയയ്ക്കുക"
        },
        "SOUND_PERMISSION_ERROR": "നിങ്ങളുടെ ബ്രൗസറിൽ ഓട്ടോപ്ലേ അപ്രാപ്തമാണ്. അലർട്ടുകൾ സ്വയം കേൾക്കാൻ, നിങ്ങളുടെ ബ്രൗസർ ക്രമീകരണങ്ങളിൽ ശബ്ദാനുമതി സജീവമാക്കുക അല്ലെങ്കിൽ പേജുമായി ഇടപെടുക.",
        "READ_MORE": "കൂടുതൽ വായിക്കുക"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "ഇമെയിൽ അറിയിപ്പുകൾ",
        "NOTE": "നിങ്ങളുടെ ഇമെയിൽ അറിയിപ്പ് മുൻ‌ഗണനകൾ ഇവിടെ അപ്‌ഡേറ്റു ചെയ്യുക",
        "CONVERSATION_ASSIGNMENT": "ഒരു സംഭാഷണം എനിക്ക് നിയോഗിക്കുമ്പോൾ ഇമെയിൽ അറിയിപ്പുകൾ അയയ്‌ക്കുക",
        "CONVERSATION_CREATION": "ഒരു പുതിയ സംഭാഷണം സൃഷ്ടിക്കുമ്പോൾ ഇമെയിൽ അറിയിപ്പുകൾ അയയ്ക്കുക",
        "CONVERSATION_MENTION": "നിങ്ങളെ ഒരു സംഭാഷണത്തിൽ പരാമർശിക്കുമ്പോൾ ഇമെയിൽ അറിയിപ്പുകൾ അയയ്ക്കുക",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "നിയമിത സംഭാഷണത്തിൽ പുതിയ സന്ദേശം സൃഷ്ടിക്കുമ്പോൾ ഇമെയിൽ അറിയിപ്പുകൾ അയയ്ക്കുക",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "പങ്കെടുക്കുന്ന സംഭാഷണത്തിൽ പുതിയ സന്ദേശം ഉണ്ടാകുമ്പോൾ ഇമെയിൽ അറിയിപ്പുകൾ അയയ്ക്കുക",
        "SLA_MISSED_FIRST_RESPONSE": "സംഭാഷണം ആദ്യ പ്രതികരണ SLA നഷ്ടപ്പെട്ടപ്പോൾ ഇമെയിൽ അറിയിപ്പുകൾ അയയ്ക്കുക",
        "SLA_MISSED_NEXT_RESPONSE": "സംഭാഷണം അടുത്ത പ്രതികരണ SLA നഷ്ടപ്പെട്ടപ്പോൾ ഇമെയിൽ അറിയിപ്പുകൾ അയയ്ക്കുക",
        "SLA_MISSED_RESOLUTION": "സംവാദം പരിഹാര SLA നഷ്ടപ്പെടുമ്പോൾ ഇമെയിൽ അറിയിപ്പുകൾ അയയ്ക്കുക"
      },
      "NOTIFICATIONS": {
        "TITLE": "അറിയിപ്പുകളുടെ മുൻഗണനകൾ",
        "TYPE_TITLE": "അറിയിപ്പ് തരം",
        "EMAIL": "ഇമെയിൽ",
        "PUSH": "പുഷ് അറിയിപ്പ്",
        "TYPES": {
          "CONVERSATION_CREATED": "ഒരു പുതിയ സംഭാഷണം സൃഷ്ടിക്കപ്പെട്ടു",
          "CONVERSATION_ASSIGNED": "ഒരു സംഭാഷണം നിങ്ങളെ നിയോഗിച്ചു",
          "CONVERSATION_MENTION": "ഒരു സംഭാഷണത്തിൽ നിങ്ങളെ പരാമർശിച്ചു",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "നീയോഗിച്ച സംഭാഷണത്തിൽ ഒരു പുതിയ സന്ദേശം സൃഷ്ടിക്കപ്പെട്ടു",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "പങ്കെടുത്തിരിക്കുന്ന സംഭാഷണത്തിൽ ഒരു പുതിയ സന്ദേശം സൃഷ്ടിക്കപ്പെട്ടു",
          "SLA_MISSED_FIRST_RESPONSE": "ഒരു സംഭാഷണം ആദ്യ പ്രതികരണ SLA നഷ്ടപ്പെടുന്നു",
          "SLA_MISSED_NEXT_RESPONSE": "ഒരു സംഭാഷണം അടുത്ത പ്രതികരണ SLA നഷ്ടപ്പെടുന്നു",
          "SLA_MISSED_RESOLUTION": "ഒരു സംഭാഷണം പരിഹാര SLA നഷ്ടപ്പെടുന്നു"
        },
        "BROWSER_PERMISSION": "നിങ്ങളുടെ ബ്രൗസറിന് പുഷ് അറിയിപ്പുകൾ സജ്ജമാക്കുക, അതിലൂടെ നിങ്ങൾക്ക് അവ സ്വീകരിക്കാനാകും"
      },
      "API": {
        "UPDATE_SUCCESS": "നിങ്ങളുടെ അറിയിപ്പ് മുൻഗണനകൾ വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",
        "UPDATE_ERROR": "മുൻ‌ഗണനകൾ അപ്‌ഡേറ്റു ചെയ്യുമ്പോൾ ഒരു പിശക് ഉണ്ട്, ദയവായി വീണ്ടും ശ്രമിക്കുക"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "പുഷ് അറിയിപ്പുകൾ",
        "NOTE": "നിങ്ങളുടെ പുഷ് അറിയിപ്പ് മുൻഗണനകൾ ഇവിടെ അപ്ഡേറ്റ് ചെയ്യുക",
        "CONVERSATION_ASSIGNMENT": "ഒരു സംഭാഷണം എനിക്ക് നിയോഗിക്കുമ്പോൾ പുഷ് അറിയിപ്പുകൾ അയയ്ക്കുക",
        "CONVERSATION_CREATION": "ഒരു പുതിയ സംഭാഷണം സൃഷ്ടിക്കുമ്പോൾ പുഷ് അറിയിപ്പുകൾ അയയ്ക്കുക",
        "CONVERSATION_MENTION": "നിങ്ങളെ ഒരു സംഭാഷണത്തിൽ പരാമർശിക്കുമ്പോൾ പുഷ് അറിയിപ്പുകൾ അയയ്ക്കുക",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "നിയമിത സംഭാഷണത്തിൽ പുതിയ സന്ദേശം സൃഷ്ടിക്കുമ്പോൾ പുഷ് അറിയിപ്പുകൾ അയയ്ക്കുക",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "പങ്കെടുക്കുന്ന സംഭാഷണത്തിൽ പുതിയ സന്ദേശം ഉണ്ടാകുമ്പോൾ പുഷ് അറിയിപ്പുകൾ അയയ്ക്കുക",
        "HAS_ENABLED_PUSH": "ഈ ബ്രൗസറിനായി നിങ്ങൾ പുഷ് സജ്ജമാക്കിയിട്ടുണ്ട്.",
        "REQUEST_PUSH": "പുഷ് അറിയിപ്പുകൾ സജ്ജമാക്കുക",
        "SLA_MISSED_FIRST_RESPONSE": "സംവാദം ആദ്യ പ്രതികരണ SLA നഷ്ടപ്പെടുമ്പോൾ പുഷ് അറിയിപ്പുകൾ അയയ്ക്കുക",
        "SLA_MISSED_NEXT_RESPONSE": "സംവാദം അടുത്ത പ്രതികരണ SLA നഷ്ടപ്പെടുമ്പോൾ പുഷ് അറിയിപ്പുകൾ അയയ്ക്കുക",
        "SLA_MISSED_RESOLUTION": "സംവാദം പരിഹാര SLA നഷ്ടപ്പെടുമ്പോൾ പുഷ് അറിയിപ്പുകൾ അയയ്ക്കുക"
      },
      "PROFILE_IMAGE": {
        "LABEL": "പ്രൊഫൈൽ ചിത്രം"
      },
      "NAME": {
        "LABEL": "നിങ്ങളുടെ മുഴുവൻ പേര്",
        "ERROR": "സാധുവായ ഒരു പൂർണ്ണ നാമം നൽകുക",
        "PLACEHOLDER": "ദയവായി നിങ്ങളുടെ മുഴുവൻ പേര് നൽകുക"
      },
      "DISPLAY_NAME": {
        "LABEL": "പ്രദർശന നാമം",
        "ERROR": "സാധുവായ ഒരു പ്രദർശന നാമം നൽകുക",
        "PLACEHOLDER": "ദയവായി ഒരു പ്രദർശന നാമം നൽകുക, ഇത് സംഭാഷണങ്ങളിൽ ദൃശ്യമാകും"
      },
      "AVAILABILITY": {
        "LABEL": "ലഭ്യത",
        "STATUS": {
          "ONLINE": "ഓൺ‌ലൈൻ",
          "BUSY": "തിരക്ക്",
          "OFFLINE": "ഓഫ്‌ലൈൻ"
        },
        "SET_AVAILABILITY_SUCCESS": "ലഭ്യത വിജയകരമായി സജ്ജമാക്കി",
        "SET_AVAILABILITY_ERROR": "ലഭ്യത സജ്ജമാക്കാൻ കഴിഞ്ഞില്ല, ദയവായി വീണ്ടും ശ്രമിക്കുക",
        "IMPERSONATING_ERROR": "ഉപയോക്താവായി നടിച്ച്‌ കൊണ്ടിരിക്കുമ്പോൾ ലഭ്യത മാറ്റാൻ കഴിയില്ല"
      },
      "EMAIL": {
        "LABEL": "നിങ്ങളുടെ ഇമെയിൽ വിലാസം",
        "ERROR": "ദയവായി സാധുവായ ഒരു ഇമെയിൽ വിലാസം നൽകുക",
        "PLACEHOLDER": "ദയവായി നിങ്ങളുടെ ഇമെയിൽ വിലാസം നൽകുക, ഇത് സംഭാഷണങ്ങളിൽ ദൃശ്യമാകും"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "നിലവിലെ പാസ്‌വേഡ്",
        "ERROR": "ദയവായി നിലവിലെ പാസ്‌വേഡ് നൽകുക",
        "PLACEHOLDER": "ദയവായി നിലവിലെ പാസ്‌വേഡ് നൽകുക"
      },
      "PASSWORD": {
        "LABEL": "പുതിയ പാസ്‌വേഡ്",
        "ERROR": "ദയവായി 6 അല്ലെങ്കിൽ അതിൽ കൂടുതൽ ദൈർഘ്യമുള്ള പാസ്‌വേഡ് നൽകുക",
        "PLACEHOLDER": "ദയവായി ഒരു പുതിയ പാസ്‌വേഡ് നൽകുക"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "പുതിയ പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക",
        "ERROR": "പാസ്‌വേഡുകൾ പൊരുത്തപ്പെടുന്നില്ല",
        "PLACEHOLDER": "നിങ്ങളുടെ പുതിയ പാസ്‌വേഡ് വീണ്ടും നൽകുക"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "മാറ്റം വരുത്തുക",
    "CHANGE_ACCOUNTS": "അക്കൗണ്ട് മാറ്റുക",
    "SWITCH_ACCOUNT": "അക്കൗണ്ട് മാറ്റുക",
    "CONTACT_SUPPORT": "സഹായവുമായി ബന്ധപ്പെടുക",
    "SELECTOR_SUBTITLE": "ഇനിപ്പറയുന്ന ലിസ്റ്റിൽ നിന്ന് ഒരു അക്കൗണ്ട് തിരഞ്ഞെടുക്കുക",
    "PROFILE_SETTINGS": "പ്രൊഫൈൽ ക്രമീകരണങ്ങൾ",
    "YEAR_IN_REVIEW": "വാർഷിക അവലോകനം",
    "KEYBOARD_SHORTCUTS": "കീബോർഡ് ഷോർട്ട്കട്ടുകൾ",
    "APPEARANCE": "ദൃശ്യ രൂപം മാറ്റുക",
    "SUPER_ADMIN_CONSOLE": "സൂപ്പർ അഡ്മിൻ കൺസോൾ",
    "DOCS": "ഡോക്യുമെന്റേഷൻ വായിക്കുക",
    "CHANGELOG": "ചേഞ്ച്‌ലോഗ്",
    "LOGOUT": "ലോഗ് ഔട്ട്"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "ദിവസത്തെ ട്രയൽ ശേഷിക്കുന്നു.",
    "TRAIL_BUTTON": "ഇപ്പോൾ വാങ്ങുക",
    "DELETED_USER": "നീക്കം ചെയ്ത ഉപയോക്താവ്",
    "EMAIL_VERIFICATION_PENDING": "നിങ്ങൾ ഇമെയിൽ വിലാസം സ്ഥിരീകരിച്ചിട്ടില്ലെന്ന് തോന്നുന്നു. ദയവായി സ്ഥിരീകരണ ഇമെയിൽ ലഭിച്ചിട്ടുണ്ടോ എന്ന് നിങ്ങളുടെ ഇൻബോക്സ് പരിശോധിക്കുക.",
    "RESEND_VERIFICATION_MAIL": "സ്ഥിരീകരണ ഇമെയിൽ വീണ്ടും അയയ്ക്കുക",
    "EMAIL_VERIFICATION_SENT": "പരിശോധന ഇമെയിൽ അയച്ചിട്ടുണ്ട്. ദയവായി നിങ്ങളുടെ ഇൻബോക്സ് പരിശോധിക്കുക.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "അക്കൗണ്ട് സസ്പെൻഡ് ചെയ്തു",
      "MESSAGE": "നിങ്ങളുടെ അക്കൗണ്ട് സസ്പെൻഡ് ചെയ്തു. കൂടുതൽ വിവരങ്ങൾക്ക് സഹായ സംഘത്തെ സമീപിക്കുക."
    },
    "NO_ACCOUNTS": {
      "TITLE": "എന്തെങ്കിലും അക്കൗണ്ട് കണ്ടെത്തിയില്ല",
      "MESSAGE_CLOUD": "നിങ്ങൾ ഇപ്പോൾ ഏതെങ്കിലും അക്കൗണ്ടിന്റെ ഭാഗമല്ല. ഇത് ഒരു പിശക് ആണെന്ന് നിങ്ങൾ കരുതുന്നുവെങ്കിൽ, ദയവായി ഞങ്ങളുടെ പിന്തുണ ടീമിനെ സമീപിക്കുക.",
      "MESSAGE_SELF_HOSTED": "നിങ്ങൾ ഇപ്പോൾ ഏതെങ്കിലും അക്കൗണ്ടിന്റെ ഭാഗമല്ല. ദയവായി നിങ്ങളുടെ അഡ്മിനിസ്ട്രേറ്ററെ സമീപിക്കുക.",
      "LOGOUT": "ലോഗ് ഔട്ട് ചെയ്യുക"
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "പകർത്തുക",
      "CODEPEN": "CodePen-ൽ തുറക്കുക",
      "COPY_SUCCESSFUL": "കോഡ് ക്ലിപ്പ്ബോർഡിലേക്ക് വിജയകരമായി പകർത്തി"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "കൂടുതൽ കാണിക്കുക",
      "SHOW_LESS": "കുറഞ്ഞത് കാണിക്കുക"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "ഡൗൺലോഡ്",
      "UPLOADING": "അപ്‌ലോഡുചെയ്യുന്നു...",
      "INSTAGRAM_STORY_UNAVAILABLE": "ഈ സ്റ്റോറി ഇനി ലഭ്യമല്ല.",
      "INSTAGRAM_STORY_REPLY": "നിങ്ങളുടെ സ്റ്റോറിയിൽ മറുപടി നൽകിയിരിക്കുന്നു:"
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "മാപ്പിൽ കാണുക"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "സമർപ്പിക്കുക"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "ഈ ചിത്രം ഇനി ലഭ്യമല്ല.",
      "LOADING_FAILED": "ലോഡിംഗ് പരാജയപ്പെട്ടു"
    }
  },
  "CONFIRM_EMAIL": "പരിശോധിച്ചുറപ്പിക്കുന്നു...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "ഇൻ‌ബോക്സ് ചേർക്കുക"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "ഇനങ്ങൾ ഇല്ല",
    "CURRENTLY_VIEWING_ACCOUNT": "ഇപ്പോൾ കാണുന്നത്:",
    "SWITCH": "മാറ്റുക",
    "INBOX_VIEW": "ഇൻബോക്സ് കാഴ്ച",
    "CONVERSATIONS": "സംഭാഷണങ്ങൾ",
    "INBOX": "എന്റെ ഇൻബോക്സ്",
    "ALL_CONVERSATIONS": "എല്ലാ സംഭാഷണങ്ങളും",
    "MENTIONED_CONVERSATIONS": "പരാമർശിക്കുന്നു",
    "PARTICIPATING_CONVERSATIONS": "പങ്കെടുത്തുകൊണ്ടിരിക്കുന്നു",
    "UNATTENDED_CONVERSATIONS": "പരിചരിക്കപ്പെടാത്തത്",
    "REPORTS": "റിപ്പോർട്ടുകൾ",
    "SETTINGS": "ക്രമീകരണങ്ങൾ",
    "CONTACTS": "കോൺ‌ടാക്റ്റുകൾ",
    "ACTIVE": "സജീവമാണ്",
    "COMPANIES": "കമ്പനികൾ",
    "ALL_COMPANIES": "എല്ലാ കമ്പനികളും",
    "CAPTAIN": "ക്യാപ്റ്റൻ",
    "CAPTAIN_ASSISTANTS": "അസിസ്റ്റന്റുകൾ",
    "CAPTAIN_OVERVIEW": "അവലോകനം",
    "CAPTAIN_DOCUMENTS": "ഡോക്യുമെന്റുകൾ",
    "CAPTAIN_RESPONSES": "അടിക്കുറിപ്പുകൾ",
    "CAPTAIN_TOOLS": "ഉപകരണങ്ങൾ",
    "CAPTAIN_SCENARIOS": "സന്നിവേശങ്ങൾ",
    "CAPTAIN_PLAYGROUND": "പ്ലേഗ്രൗണ്ട്",
    "CAPTAIN_INBOXES": "ഇൻ‌ബോക്സുകൾ",
    "CAPTAIN_SETTINGS": "ക്രമീകരണങ്ങൾ",
    "HOME": "ഹോം",
    "AGENTS": "ഏജന്റുമാർ",
    "AGENT_BOTS": "ബോട്ടുകൾ",
    "AUDIT_LOGS": "ഓഡിറ്റ് ലോഗുകൾ",
    "INBOXES": "ഇൻ‌ബോക്സുകൾ",
    "NOTIFICATIONS": "അറിയിപ്പുകൾ",
    "CANNED_RESPONSES": "ക്യാൻഡ് പ്രതികരണങ്ങൾ",
    "INTEGRATIONS": "സംയോജനങ്ങൾ",
    "DATA": "Data",
    "PROFILE_SETTINGS": "പ്രൊഫൈൽ ക്രമീകരണങ്ങൾ",
    "ACCOUNT_SETTINGS": "അക്കൗണ്ട് ക്രമീകരണങ്ങൾ",
    "APPLICATIONS": "അപ്ലിക്കേഷനുകൾ",
    "LABELS": "ലേബലുകൾ",
    "CUSTOM_ATTRIBUTES": "ഇഷ്‌ടാനുസൃത ആട്രിബ്യൂട്ടുകൾ",
    "AUTOMATION": "ഓട്ടോമേഷൻ",
    "MACROS": "മാക്രോകൾ",
    "TEAMS": "ടീമുകൾ",
    "BILLING": "ബില്ലിംഗ്",
    "CUSTOM_VIEWS_FOLDER": "ഫോൾഡറുകൾ",
    "CUSTOM_VIEWS_SEGMENTS": "അംശങ്ങൾ",
    "ALL_CONTACTS": "എല്ലാ കോൺടാക്റ്റുകളും",
    "TAGGED_WITH": "ടാഗ് ചെയ്തിരിക്കുന്നത്",
    "NEW_LABEL": "പുതിയ ലേബൽ",
    "NEW_TEAM": "പുതിയ ടീം",
    "NEW_INBOX": "പുതിയ ഇൻബോക്സ്",
    "REPORTS_CONVERSATION": "സംഭാഷണങ്ങൾ",
    "CSAT": "CSAT",
    "LIVE_CHAT": "ലൈവ് ചാറ്റ്",
    "SMS": "എസ്എംഎസ്",
    "WHATSAPP": "WhatsApp",
    "CAMPAIGNS": "പ്രചാരണങ്ങൾ",
    "ONGOING": "നടന്നു കൊണ്ടിരിക്കുന്നു",
    "ONE_OFF": "ഒരിക്കൽ മാത്രം",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "ബോട്ട്",
    "REPORTS_AGENT": "ഏജന്റുമാർ",
    "REPORTS_LABEL": "ലേബലുകൾ",
    "REPORTS_INBOX": "ഇൻബോക്സ്",
    "REPORTS_TEAM": "ടീം",
    "AGENT_ASSIGNMENT": "ഏജന്റ് നിയോഗം",
    "SET_AVAILABILITY_TITLE": "താങ്കളെ ആയി സജ്ജമാക്കുക",
    "SET_YOUR_AVAILABILITY": "നിങ്ങളുടെ ലഭ്യത സജ്ജമാക്കുക",
    "SLA": "SLA",
    "CUSTOM_ROLES": "സ്വകാര്യ റോളുകൾ",
    "BETA": "ബീറ്റ",
    "REPORTS_OVERVIEW": "അവലോകനം",
    "REAUTHORIZE": "നിങ്ങളുടെ ഇൻബോക്സ് കണക്ഷൻ കാലഹരണപ്പെട്ടു, ദയവായി വീണ്ടും കണക്ട് ചെയ്യുക\nസന്ദേശങ്ങൾ സ്വീകരിക്കുകയും അയയ്ക്കുകയും തുടരാൻ",
    "HELP_CENTER": {
      "TITLE": "സഹായ കേന്ദ്രം",
      "ARTICLES": "ലേഖനങ്ങൾ",
      "CATEGORIES": "വിഭാഗങ്ങൾ",
      "LOCALES": "പ്രാദേശികങ്ങൾ",
      "SETTINGS": "ക്രമീകരണങ്ങൾ"
    },
    "CHANNELS": "ചാനലുകൾ",
    "SET_AUTO_OFFLINE": {
      "TEXT": "സ്വയം ഓഫ്‌ലൈൻ ആയി അടയാളപ്പെടുത്തുക",
      "INFO_TEXT": "നിങ്ങൾ ആപ്പ് അല്ലെങ്കിൽ ഡാഷ്ബോർഡ് ഉപയോഗിക്കാത്തപ്പോൾ സിസ്റ്റം സ്വയം നിങ്ങളെ ഓഫ്‌ലൈൻ ആയി അടയാളപ്പെടുത്തട്ടെ.",
      "INFO_SHORT": "ആപ്പ് ഉപയോഗിക്കാത്തപ്പോൾ സ്വയം ഓട്ടോമാറ്റിക്കായി ഓഫ്‌ലൈൻ ആയി അടയാളപ്പെടുത്തുക."
    },
    "SORT_TOOLTIP": "Sort",
    "SORT_BY": "Sort by",
    "SORT_GROUPS": {
      "CREATED": "Sort by date of creation",
      "ALPHABETICAL": "Sort in alphabetical order",
      "UNREAD_COUNT": "Sort by unread count"
    },
    "SORT_OPTIONS": {
      "CREATED_DESC": "Newest first",
      "CREATED_ASC": "Oldest first",
      "ALPHABETICAL_ASC": "Ascending (A - Z)",
      "ALPHABETICAL_DESC": "Descending (Z - A)",
      "UNREAD_COUNT_DESC": "Highest first",
      "UNREAD_COUNT_ASC": "Lowest first"
    },
    "DOCS": "ഡോക്യുമെന്റുകൾ വായിക്കുക",
    "SECURITY": "സുരക്ഷ",
    "CAPTAIN_AI": "ക്യാപ്റ്റൻ",
    "CONVERSATION_WORKFLOW": "സംവാദ പ്രവാഹം"
  },
  "DATA_IMPORTS": {
    "HEADER": "Data",
    "DESCRIPTION": "Bring your existing contacts and past conversations into this account from another support tool. Each import runs in the background, so you can keep working while it finishes, track its progress, and review anything that was skipped along the way.",
    "LOADING": "Fetching imports",
    "DEFAULT_IMPORT_NAME": "Intercom import",
    "TABS": {
      "IMPORT": "Import",
      "EXPORT": "Export"
    },
    "TYPES": {
      "CONTACTS": "കോൺ‌ടാക്റ്റുകൾ",
      "CONVERSATIONS": "സംഭാഷണങ്ങൾ",
      "MESSAGES": "Messages"
    },
    "DRAWER": {
      "TITLE": "New import",
      "SOURCE": "Source",
      "NAME": "Import name",
      "NAME_PLACEHOLDER": "July Intercom migration",
      "ACCESS_KEY": "Intercom access key",
      "ACCESS_KEY_PLACEHOLDER": "Paste your Intercom access key",
      "DATA_TYPES": "Data to import",
      "VALIDATING": "Validating access key...",
      "VALID_KEY": "Access key validated.",
      "INVALID_KEY": "Could not validate this access key.",
      "ACTIVE_IMPORT": "Wait for the active import to finish before starting another one.",
      "CANCEL": "റദ്ദാക്കുക",
      "IMPORT": "Import"
    },
    "EXPORT": {
      "TITLE": "Exports are on the way",
      "DESCRIPTION": "Export your contacts and conversations out of this account. This workflow is coming soon.",
      "COMING_SOON": "വളരെ ഉടൻ"
    },
    "TABLE": {
      "TITLE": "Recent imports",
      "EMPTY": "No imports yet",
      "EMPTY_DESCRIPTION": "Start an import to bring your existing customer history into this account.",
      "NEW_IMPORT": "Import",
      "COUNT": "{count} imports",
      "UNNAMED": "Untitled import",
      "IMPORTED_COUNT": "{count} imported",
      "VIEW": "View import",
      "NAME": "പേര്",
      "TYPE": "Type",
      "STATUS": "സ്റ്റാറ്റസ്",
      "IMPORTED": "Imported",
      "CREATED": "Created",
      "ABANDON": "Abandon"
    },
    "DETAIL": {
      "BACK": "Back to imports",
      "ERRORS": "Errors",
      "SKIP_LOGS": "Skip logs",
      "SOURCE": "Source",
      "IMPORT_TYPES": "Import types",
      "CREATED": "Created",
      "DURATION": "Duration",
      "INITIATED_BY": "Started by",
      "PROGRESS": "Import progress",
      "PROGRESS_WITH_TOTAL": "{imported} of {total} imported",
      "PROGRESS_WITHOUT_TOTAL": "{imported} imported",
      "PROGRESS_OF_TOTAL": "of {total} imported",
      "PROGRESS_IMPORTED": "imported",
      "LAST_UPDATED_TOOLTIP": "Last updated {time}",
      "NO_SKIP_LOGS": "No skipped or failed records recorded.",
      "DOWNLOAD_SKIP_LOGS": "Download CSV",
      "DOWNLOAD_ERROR_LOGS": "Download CSV",
      "ALL_SKIP_LOGS": "എല്ലാം",
      "KIND": "Kind",
      "NO_ERRORS": "No errors recorded.",
      "ERROR_CODE": "Code",
      "SOURCE_OBJECT": "Source object",
      "MESSAGE": "സന്ദേശം"
    },
    "MONITOR": {
      "LIVE": "Live updates every {seconds}s",
      "LAST_UPDATED": "Last updated {time}",
      "REFRESH": "Refresh",
      "REFRESHING": "Refreshing",
      "STAGES": {
        "unknown": "Waiting for update",
        "queued": "Queued",
        "contacts": "Importing contacts",
        "conversations": "Importing conversations",
        "finalizing": "Finalizing import",
        "completed": "പൂർത്തിയാക്കി",
        "completed_with_errors": "Completed with errors",
        "failed": "Failed",
        "abandoned": "Abandoned"
      }
    },
    "ALERTS": {
      "IMPORT_STARTED": "Intercom import has started.",
      "IMPORT_ABANDONED": "Intercom import has been abandoned.",
      "IMPORT_FAILED": "Could not start the Intercom import."
    }
  },
  "CAPTAIN_SETTINGS": {
    "TITLE": "ക്യാപ്റ്റൻ ക്രമീകരണങ്ങൾ",
    "DESCRIPTION": "ക്യാപ്റ്റനായി നിങ്ങളുടെ AI മോഡലുകളും ഫീച്ചറുകളും ക്രമീകരിക്കുക. ക്യാപ്റ്റൻ ക്രെഡിറ്റ് അടിസ്ഥാനത്തിലുള്ള ബില്ലിംഗ് പിന്തുടരുന്നു, തിരഞ്ഞെടുക്കപ്പെട്ട മോഡലിന്റെ അടിസ്ഥാനത്തിൽ ക്യാപ്റ്റൻ എടുക്കുന്ന ഓരോ പ്രവർത്തനത്തിനും നിങ്ങൾക്ക് ക്രെഡിറ്റുകൾ ചാർജ് ചെയ്യപ്പെടും.",
    "LOADING": "ക്യാപ്റ്റൻ കോൺഫിഗറേഷൻ ലോഡ് ചെയ്യുന്നു...",
    "LINK_TEXT": "ക്യാപ്റ്റൻ ക്രെഡിറ്റുകൾക്കുറിച്ച് കൂടുതൽ അറിയുക",
    "NOT_ENABLED": "നിങ്ങളുടെ അക്കൗണ്ടിന് ക്യാപ്റ്റൻ സജ്ജമാക്കിയിട്ടില്ല. ക്യാപ്റ്റൻ ഫീച്ചറുകൾ ഉപയോഗിക്കാൻ ദയവായി നിങ്ങളുടെ പ്ലാൻ അപ്ഗ്രേഡ് ചെയ്യുക.",
    "MODEL_CONFIG": {
      "TITLE": "മോഡൽ കോൺഫിഗറേഷൻ",
      "DESCRIPTION": "വിവിധ ഫീച്ചറുകൾക്കായി AI മോഡലുകൾ തിരഞ്ഞെടുക്കുക.",
      "SELECT_MODEL": "മോഡൽ തിരഞ്ഞെടുക്കുക",
      "CREDITS_PER_MESSAGE": "{credits} ക്രെഡിറ്റ്/സന്ദേശം",
      "COMING_SOON": "വളരെ ഉടൻ",
      "EDITOR": {
        "TITLE": "എഡിറ്റർ സവിശേഷതകൾ",
        "DESCRIPTION": "നിങ്ങളുടെ സന്ദേശ എഡിറ്ററിൽ സ്മാർട്ട് കോമ്പോസ്, വ്യാകരണ തിരുത്തലുകൾ, ടോൺ ക്രമീകരണങ്ങൾ, ഉള്ളടക്ക മെച്ചപ്പെടുത്തൽ എന്നിവയ്ക്ക് ശക്തി നൽകുന്നു."
      },
      "ASSISTANT": {
        "TITLE": "അസിസ്റ്റന്റ്",
        "DESCRIPTION": "ഉപഭോക്തൃ ഇടപെടലുകൾക്കായി സ്വയംപ്രവർത്തിക്കുന്ന പ്രതികരണങ്ങൾ, സംഭാഷണ സംഗ്രഹങ്ങൾ, ബുദ്ധിമുട്ടുള്ള മറുപടി നിർദ്ദേശങ്ങൾ എന്നിവ കൈകാര്യം ചെയ്യുന്നു."
      },
      "COPILOT": {
        "TITLE": "കോ-പൈലറ്റ്",
        "DESCRIPTION": "സംഭാഷണങ്ങളുടെ സമയത്ത് യാഥാർത്ഥ്യപരമായ സാന്ദർഭിക നിർദ്ദേശങ്ങൾ, അറിവ് അടിസ്ഥാന ശുപാർശകൾ, പ്രോആക്റ്റീവ് ഉൾക്കാഴ്ചകൾ നൽകുന്നു."
      }
    },
    "FEATURES": {
      "TITLE": "സവിശേഷതകൾ",
      "DESCRIPTION": "AI-ശക്തിയുള്ള ഫീച്ചറുകൾ സജീവമാക്കുക അല്ലെങ്കിൽ അപ്രാപ്തമാക്കുക.",
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "ഓഡിയോ ട്രാൻസ്ക്രിപ്ഷൻ",
        "DESCRIPTION": "വോയ്സ് സന്ദേശങ്ങളും കോൾ റെക്കോർഡിംഗുകളും സ്വയം തിരയാവുന്ന ടെക്സ്റ്റ് ട്രാൻസ്ക്രിപ്റ്റുകളായി മാറ്റുക.",
        "MODEL_TITLE": "Audio Transcription Model",
        "MODEL_DESCRIPTION": "Select the AI model to use for converting audio messages into text transcripts"
      },
      "HELP_CENTER_SEARCH": {
        "TITLE": "ഹെൽപ്പ് സെന്റർ സെർച്ച് ഇൻഡക്സിംഗ്",
        "DESCRIPTION": "നിങ്ങളുടെ ഹെൽപ്പ് സെന്റർ ലേഖനങ്ങളിൽ സാന്ദർഭിക ബോധമുള്ള AI ഉപയോഗിച്ച് തിരയുക."
      },
      "LABEL_SUGGESTION": {
        "TITLE": "ലേബൽ നിർദ്ദേശം",
        "DESCRIPTION": "സംവാദങ്ങളുടെ ഉള്ളടക്ക വിശകലനവും സാഹചര്യവും അടിസ്ഥാനമാക്കി സ്വയംപ്രേരിതമായി അനുയോജ്യമായ ലേബലുകളും ടാഗുകളും നിർദ്ദേശിക്കുക.",
        "MODEL_TITLE": "ലേബൽ നിർദ്ദേശ മോഡൽ",
        "MODEL_DESCRIPTION": "സംവാദങ്ങൾ വിശകലനം ചെയ്ത് അനുയോജ്യമായ ലേബലുകൾ നിർദ്ദേശിക്കാൻ ഉപയോഗിക്കാനുള്ള AI മോഡൽ തിരഞ്ഞെടുക്കുക"
      }
    },
    "API": {
      "SUCCESS": "ക്യാപ്റ്റൻ ക്രമീകരണങ്ങൾ വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു.",
      "ERROR": "Captain ക്രമീകരണങ്ങൾ അപ്ഡേറ്റ് ചെയ്യാൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക."
    }
  },
  "BILLING_SETTINGS": {
    "TITLE": "ബില്ലിംഗ്",
    "DESCRIPTION": "നിങ്ങളുടെ സബ്സ്ക്രിപ്ഷൻ ഇവിടെ നിയന്ത്രിക്കുക, നിങ്ങളുടെ പ്ലാൻ അപ്‌ഗ്രേഡ് ചെയ്യുക, നിങ്ങളുടെ ടീമിനായി കൂടുതൽ നേടുക.",
    "CURRENT_PLAN": {
      "TITLE": "നിലവിലെ പ്ലാൻ",
      "PLAN_NOTE": "നിങ്ങൾ നിലവിൽ **{plan}** പ്ലാനിൽ **{quantity}** ലൈസൻസുകളോടെ സബ്സ്ക്രൈബ് ചെയ്തിരിക്കുന്നു",
      "SEAT_COUNT": "സീറ്റുകളുടെ എണ്ണം",
      "RENEWS_ON": "പുതുക്കുന്നത്",
      "CURRENCY": "Currency"
    },
    "CURRENCY": {
      "SELECT": {
        "TITLE": "Choose your billing currency",
        "DESCRIPTION": "Select the currency you'd like to be billed in. This can't be changed once your subscription is created."
      },
      "OPTIONS": {
        "USD": "US Dollar (USD)",
        "BRL": "Brazilian Real (BRL)"
      }
    },
    "VIEW_PRICING": "വിലകൾ കാണുക",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "നിങ്ങളുടെ സബ്സ്ക്രിപ്ഷൻ നിയന്ത്രിക്കുക",
      "DESCRIPTION": "നിങ്ങളുടെ മുൻ ഇൻവോയിസുകൾ കാണുക, ബില്ലിംഗ് വിശദാംശങ്ങൾ തിരുത്തുക, അല്ലെങ്കിൽ സബ്സ്ക്രിപ്ഷൻ റദ്ദാക്കുക.",
      "BUTTON_TXT": "ബില്ലിംഗ് പോർട്ടലിലേക്ക് പോകുക"
    },
    "CAPTAIN": {
      "TITLE": "ക്യാപ്റ്റൻ",
      "DESCRIPTION": "ക്യാപ്റ്റൻ AI-യുടെ ഉപയോഗവും ക്രെഡിറ്റുകളും നിയന്ത്രിക്കുക.",
      "BUTTON_TXT": "കൂടുതൽ ക്രെഡിറ്റുകൾ വാങ്ങുക",
      "DOCUMENTS": "ഡോക്യുമെന്റുകൾ",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain സൗജന്യ പ്ലാനിൽ ലഭ്യമല്ല, അസിസ്റ്റന്റുകൾ, കോപൈലറ്റ് എന്നിവയ്ക്ക് ആക്‌സസ് നേടാൻ ഇപ്പോൾ അപ്‌ഗ്രേഡ് ചെയ്യുക.",
      "REFRESH_CREDITS": "പുതുക്കുക"
    },
    "CHAT_WITH_US": {
      "TITLE": "സഹായം വേണോ?",
      "DESCRIPTION": "ബില്ലിംഗ് സംബന്ധിച്ച പ്രശ്നങ്ങളുണ്ടോ? ഞങ്ങൾ സഹായത്തിനായി ഇവിടെ ഉണ്ടാകുന്നു.",
      "BUTTON_TXT": "ഞങ്ങളുമായി ചാറ്റുചെയ്യുക"
    },
    "NO_BILLING_USER": "നിങ്ങളുടെ ബില്ലിംഗ് അക്കൗണ്ട് ക്രമീകരിക്കപ്പെടുകയാണ്. ദയവായി പേജ് റിഫ്രഷ് ചെയ്ത് വീണ്ടും ശ്രമിക്കുക.",
    "TOPUP": {
      "BUY_CREDITS": "കൂടുതൽ ക്രെഡിറ്റുകൾ വാങ്ങുക",
      "MODAL_TITLE": "AI ക്രെഡിറ്റുകൾ വാങ്ങുക",
      "MODAL_DESCRIPTION": "Captain AI-ക്കായി അധിക ക്രെഡിറ്റുകൾ വാങ്ങുക.",
      "CREDITS": "ക്രെഡിറ്റുകൾ",
      "ONE_TIME": "ഒരിക്കൽ മാത്രം",
      "POPULAR": "ഏറ്റവും പ്രശസ്തം",
      "NOTE_TITLE": "കുറിപ്പ്:",
      "NOTE_DESCRIPTION": "ക്രെഡിറ്റുകൾ ഉടൻ ചേർക്കപ്പെടുകയും 6 മാസത്തിനുള്ളിൽ കാലഹരണപ്പെടുകയും ചെയ്യും. ക്രെഡിറ്റുകൾ ഉപയോഗിക്കാൻ സജീവ സബ്സ്ക്രിപ്ഷൻ ആവശ്യമാണ്. വാങ്ങിയ ക്രെഡിറ്റുകൾ നിങ്ങളുടെ മാസാന്ത പ്ലാൻ ക്രെഡിറ്റുകൾ ഉപയോഗിച്ചതിന് ശേഷം ഉപയോക്താവാകും.",
      "CANCEL": "റദ്ദാക്കുക",
      "PURCHASE": "ക്രെഡിറ്റുകൾ വാങ്ങുക",
      "LOADING": "ഓപ്ഷനുകൾ ലോഡ് ചെയ്യുന്നു...",
      "FETCH_ERROR": "ക്രെഡിറ്റ് ഓപ്ഷനുകൾ ലോഡ് ചെയ്യാൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
      "RETRY": "Retry",
      "PURCHASE_ERROR": "വാങ്ങൽ പ്രക്രിയ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
      "PURCHASE_SUCCESS": "നിങ്ങളുടെ അക്കൗണ്ടിലേക്ക് {credits} ക്രെഡിറ്റുകൾ വിജയകരമായി ചേർത്തു",
      "CONFIRM": {
        "TITLE": "വാങ്ങൽ സ്ഥിരീകരിക്കുക",
        "DESCRIPTION": "നിങ്ങൾ {amount} വിലയ്ക്ക് {credits} ക്രെഡിറ്റുകൾ വാങ്ങാൻ പോകുന്നു.",
        "INSTANT_DEDUCTION_NOTE": "സ്ഥിരപ്പെടുത്തിയ കാർഡിൽ സ്ഥിരീകരണത്തിന് ശേഷം ഉടൻ പണം വെട്ടിച്ചേർക്കും.",
        "GO_BACK": "പിന്നിലേക്ക് പോകുക",
        "CONFIRM_PURCHASE": "വാങ്ങൽ സ്ഥിരീകരിക്കുക"
      }
    }
  },
  "SECURITY_SETTINGS": {
    "TITLE": "സുരക്ഷ",
    "DESCRIPTION": "നിങ്ങളുടെ അക്കൗണ്ട് സുരക്ഷാ ക്രമീകരണങ്ങൾ നിയന്ത്രിക്കുക.",
    "LINK_TEXT": "SAML SSOയെക്കുറിച്ച് കൂടുതൽ അറിയുക",
    "SAML_DISABLED_MESSAGE": "SAML SSO ഇപ്പോൾ പ്രവർത്തനരഹിതമാണ്. ഈ സവിശേഷത സജീവമാക്കാൻ ദയവായി നിങ്ങളുടെ അഡ്മിനിസ്ട്രേറ്ററെ ബന്ധപ്പെടുക.",
    "SAML": {
      "TITLE": "SAML SSO",
      "NOTE": "നിങ്ങളുടെ അക്കൗണ്ടിനായി SAML സിംഗിൾ സൈൻ-ഓൺ ക്രമീകരിക്കുക. ഉപയോക്താക്കൾ ഇമെയിൽ/പാസ്‌വേഡ് ഉപയോഗിക്കുന്നതിന് പകരം നിങ്ങളുടെ ഐഡന്റിറ്റി പ്രൊവൈഡറിലൂടെ പ്രാമാണീകരിക്കും.",
      "ACS_URL": {
        "LABEL": "ACS URL",
        "TOOLTIP": "അസർഷൻ കൺസ്യൂമർ സർവീസ് URL - SAML പ്രതികരണങ്ങളുടെ ലക്ഷ്യസ്ഥാനമായി നിങ്ങളുടെ IdP-യിൽ ഈ URL ക്രമീകരിക്കുക"
      },
      "SSO_URL": {
        "LABEL": "SSO URL",
        "HELP": "SAML പ്രാമാണീകരണ അഭ്യർത്ഥനകൾ അയയ്ക്കപ്പെടുന്ന URL",
        "PLACEHOLDER": "https://your-idp.com/saml/sso"
      },
      "CERTIFICATE": {
        "LABEL": "PEM ഫോർമാറ്റിലുള്ള സൈൻ ചെയ്യൽ സർട്ടിഫിക്കറ്റ്",
        "HELP": "SAML പ്രതികരണങ്ങൾ പരിശോധിക്കാൻ നിങ്ങളുടെ ഐഡന്റിറ്റി പ്രൊവൈഡറിന്റെ പബ്ലിക് സർട്ടിഫിക്കറ്റ്",
        "PLACEHOLDER": "-----BEGIN CERTIFICATE-----\nMIIC..."
      },
      "FINGERPRINT": {
        "LABEL": "ഫിംഗർപ്രിന്റ്",
        "TOOLTIP": "സർട്ടിഫിക്കറ്റിന്റെ SHA-1 ഫിംഗർപ്രിന്റ് - നിങ്ങളുടെ IdP കോൺഫിഗറേഷനിൽ സർട്ടിഫിക്കറ്റ് സ്ഥിരീകരിക്കാൻ ഇത് ഉപയോഗിക്കുക"
      },
      "COPY_SUCCESS": "കോഡ് ക്ലിപ്പ്ബോർഡിലേക്ക് വിജയകരമായി പകർത്തി",
      "SP_ENTITY_ID": {
        "LABEL": "SP എന്റിറ്റി ഐഡി",
        "HELP": "സേവനദാതാവായി ഈ ആപ്ലിക്കേഷനു വേണ്ടി യുണീക്ക് ഐഡന്റിഫയർ (സ്വയം സൃഷ്ടിച്ചത്).",
        "TOOLTIP": "സേവനദാതാവായി Chatwoot ന്റെ യുണീക്ക് ഐഡന്റിഫയർ - നിങ്ങളുടെ IdP ക്രമീകരണങ്ങളിൽ ഇത് ക്രമീകരിക്കുക"
      },
      "IDP_ENTITY_ID": {
        "LABEL": "ഐഡന്റിറ്റി പ്രൊവൈഡർ എന്റിറ്റി ഐഡി",
        "HELP": "നിങ്ങളുടെ ഐഡന്റിറ്റി പ്രൊവൈഡറിനുള്ള ഏകത്വ ഐഡന്റിഫയർ (സാധാരണയായി IdP കോൺഫിഗറേഷനിൽ കാണപ്പെടുന്നു)",
        "PLACEHOLDER": "https://your-idp.com/saml"
      },
      "UPDATE_BUTTON": "SAML ക്രമീകരണങ്ങൾ അപ്ഡേറ്റ് ചെയ്യുക",
      "API": {
        "SUCCESS": "SAML ക്രമീകരണങ്ങൾ വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",
        "ERROR": "SAML ക്രമീകരണങ്ങൾ അപ്ഡേറ്റ് ചെയ്യാൻ പരാജയപ്പെട്ടു",
        "ERROR_LOADING": "SAML ക്രമീകരണങ്ങൾ ലോഡ് ചെയ്യാൻ പരാജയപ്പെട്ടു",
        "DISABLED": "SAML ക്രമീകരണങ്ങൾ വിജയകരമായി അപ്രാപ്തമാക്കി"
      },
      "VALIDATION": {
        "REQUIRED_FIELDS": "SSO URL, ഐഡന്റിറ്റി പ്രൊവൈഡർ Entity ID, സർട്ടിഫിക്കറ്റ് എന്നിവ ആവശ്യമായ ഫീൽഡുകളാണ്",
        "SSO_URL_ERROR": "ദയവായി സാധുവായ SSO URL നൽകുക",
        "CERTIFICATE_ERROR": "സർട്ടിഫിക്കറ്റ് ആവശ്യമാണ്",
        "IDP_ENTITY_ID_ERROR": "ഐഡന്റിറ്റി പ്രൊവൈഡർ എന്റിറ്റി ഐഡി ആവശ്യമാണ്"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "SAML SSO ഫീച്ചർ എന്റർപ്രൈസ് പ്ലാനുകളിൽ മാത്രമേ ലഭ്യമാകൂ.",
        "UPGRADE_PROMPT": "SAML സിംഗിൾ സൈൻ-ഓൺ ഉൾപ്പെടെയുള്ള മറ്റ് ആധുനിക സുരക്ഷാ ഫീച്ചറുകൾ ഉപയോഗിക്കാൻ എന്റർപ്രൈസ് പ്ലാനിലേക്ക് അപ്ഗ്രേഡ് ചെയ്യുക.",
        "ASK_ADMIN": "അപ്ഗ്രേഡിനായി ദയവായി നിങ്ങളുടെ അഡ്മിനിസ്ട്രേറ്ററെ സമീപിക്കുക."
      },
      "PAYWALL": {
        "TITLE": "SAML SSO സജീവമാക്കാൻ അപ്ഗ്രേഡ് ചെയ്യുക",
        "AVAILABLE_ON": "SAML SSO ഫീച്ചർ എന്റർപ്രൈസ് പ്ലാനുകളിൽ മാത്രമേ ലഭ്യമാകൂ.",
        "UPGRADE_PROMPT": "SAML സിംഗിൾ സൈൻ-ഓൺ ഉൾപ്പെടെ മറ്റ് പുരോഗമന ഫീച്ചറുകൾ ലഭിക്കാൻ നിങ്ങളുടെ പ്ലാൻ അപ്ഗ്രേഡ് ചെയ്യുക.",
        "UPGRADE_NOW": "ഇപ്പോൾ അപ്ഗ്രേഡ് ചെയ്യുക",
        "CANCEL_ANYTIME": "നിങ്ങൾക്ക് എപ്പോഴും നിങ്ങളുടെ പ്ലാൻ മാറ്റാനും റദ്ദാക്കാനും കഴിയും"
      },
      "ATTRIBUTE_MAPPING": {
        "TITLE": "SAML ഗുണലക്ഷണ ക്രമീകരണം",
        "DESCRIPTION": "താഴെപ്പറയുന്ന ഗുണലക്ഷണ മാപ്പിംഗ് നിങ്ങളുടെ ഐഡന്റിറ്റി പ്രൊവൈഡറിൽ ക്രമീകരിക്കണം"
      },
      "INFO_SECTION": {
        "TITLE": "സർവീസ് പ്രൊവൈഡർ വിവരങ്ങൾ",
        "TOOLTIP": "ഈ മൂല്യങ്ങൾ പകർത്തി നിങ്ങളുടെ ഐഡന്റിറ്റി പ്രൊവൈഡറിൽ ക്രമീകരിച്ച് SAML ബന്ധം സ്ഥാപിക്കുക"
      }
    }
  },
  "CONVERSATION_WORKFLOW": {
    "INDEX": {
      "HEADER": {
        "TITLE": "സംവാദ പ്രവാഹങ്ങൾ",
        "DESCRIPTION": "സംവാദ പരിഹാരത്തിനായി നിയമങ്ങളും ആവശ്യമായ ഫീൽഡുകളും ക്രമീകരിക്കുക."
      }
    },
    "REQUIRED_ATTRIBUTES": {
      "TITLE": "പരിഹാരത്തിന് ആവശ്യമായ ഗുണങ്ങൾ",
      "DESCRIPTION": "ഒരു സംഭാഷണം പരിഹരിക്കുമ്പോൾ, ഏജന്റുകൾക്ക് ഈ ഗുണലക്ഷണങ്ങൾ പൂരിപ്പിക്കാൻ പ്രേരിപ്പിക്കപ്പെടും, അവർ ഇതുവരെ പൂരിപ്പിച്ചിട്ടില്ലെങ്കിൽ.",
      "NO_ATTRIBUTES": "ഇപ്പോൾ വരെ ഗുണലക്ഷണങ്ങൾ ചേർത്തിട്ടില്ല",
      "ADD": {
        "TITLE": "ഗുണലക്ഷണങ്ങൾ ചേർക്കുക",
        "SEARCH_PLACEHOLDER": "ഗുണലക്ഷണങ്ങൾ തിരയുക"
      },
      "SAVE": {
        "SUCCESS": "ആവശ്യമായ ഗുണലക്ഷണങ്ങൾ അപ്ഡേറ്റ് ചെയ്തു",
        "ERROR": "ആവശ്യമായ ഗുണങ്ങൾ അപ്ഡേറ്റ് ചെയ്യാൻ കഴിഞ്ഞില്ല, ദയവായി വീണ്ടും ശ്രമിക്കുക"
      },
      "MODAL": {
        "TITLE": "സംഭാഷണം പരിഹരിക്കുക",
        "DESCRIPTION": "ഈ സംഭാഷണം പരിഹരിക്കുന്നതിന് മുമ്പ് താഴെ കാണുന്ന കസ്റ്റം ഗുണങ്ങൾ പൂരിപ്പിക്കുക",
        "ACTIONS": {
          "RESOLVE": "സംഭാഷണം പരിഹരിക്കുക",
          "CANCEL": "റദ്ദാക്കുക"
        },
        "PLACEHOLDERS": {
          "TEXT": "ഒരു കുറിപ്പ് എഴുതുക...",
          "NUMBER": "ഒരു നമ്പർ നൽകുക",
          "LINK": "ഒരു ലിങ്ക് ചേർക്കുക",
          "DATE": "ഒരു തീയതി തിരഞ്ഞെടുക്കുക",
          "LIST": "ഒരു ഓപ്ഷൻ തിരഞ്ഞെടുക്കുക"
        },
        "CHECKBOX": {
          "YES": "അതെ",
          "NO": "ഇല്ല"
        }
      },
      "PAYWALL": {
        "TITLE": "ആവശ്യമായ ഗുണങ്ങൾ ഉപയോഗിക്കാൻ അപ്ഗ്രേഡ് ചെയ്യുക",
        "AVAILABLE_ON": "ആവശ്യമായ സംഭാഷണ ഗുണങ്ങൾ ബിസിനസ്സ്, എന്റർപ്രൈസ് പ്ലാനുകളിൽ ലഭ്യമാണ്.",
        "UPGRADE_PROMPT": "സംഭാഷണം പരിഹരിക്കുന്നതിന് മുമ്പ് ഏജന്റുമാരെ ആവശ്യമായ ഗുണങ്ങൾ പൂരിപ്പിക്കാൻ പ്രേരിപ്പിക്കാൻ നിങ്ങളുടെ പ്ലാൻ അപ്ഗ്രേഡ് ചെയ്യുക.",
        "UPGRADE_NOW": "ഇപ്പോൾ അപ്ഗ്രേഡ് ചെയ്യുക",
        "CANCEL_ANYTIME": "നിങ്ങളുടെ പ്ലാൻ എപ്പോഴും മാറ്റുകയോ റദ്ദാക്കുകയോ ചെയ്യാം"
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "ആവശ്യമായ സംഭാഷണ ഗുണങ്ങൾ പണമടയ്ക്കുന്ന പ്ലാനുകളിൽ ലഭ്യമാണ്.",
        "UPGRADE_PROMPT": "സംഭാഷണം തീരുന്നതിന് മുമ്പ് ആവശ്യമായ ഗുണങ്ങൾ നിർബന്ധമാക്കാൻ പണമടയ്ക്കുന്ന പ്ലാനിലേക്ക് അപ്‌ഗ്രേഡ് ചെയ്യുക.",
        "ASK_ADMIN": "അപ്‌ഗ്രേഡിനായി ദയവായി നിങ്ങളുടെ അഡ്മിനിസ്ട്രേറ്ററെ സമീപിക്കുക."
      }
    }
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "അയ്യോ! ഞങ്ങൾക്ക് ഏതെങ്കിലും Chatwoot അക്കൗണ്ടുകൾ കണ്ടെത്താനായില്ല. തുടരാൻ ദയവായി ഒരു പുതിയ അക്കൗണ്ട് സൃഷ്ടിക്കുക.",
    "NEW_ACCOUNT": "പുതിയ അക്കൗണ്ട്",
    "SELECTOR_SUBTITLE": "അക്കൗണ്ട് ഒരു പുതിയ അക്കൗണ്ട് വിജയകരമായി സൃഷ്ടിക്കുക",
    "API": {
      "SUCCESS_MESSAGE": "അക്കൗണ്ട് വിജയകരമായി സൃഷ്ടിച്ചു",
      "EXIST_MESSAGE": "അക്കൗണ്ട് ഇതിനകം നിലവിലുണ്ട്",
      "ERROR_MESSAGE": "വൂട്ട് സെർവറിലേക്ക് കണക്റ്റുചെയ്യാനായില്ല, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക"
    },
    "FORM": {
      "NAME": {
        "LABEL": "കമ്പനിയുടെ പേര്",
        "PLACEHOLDER": "പുണ്ണ്യാളൻ അഗർബത്തീസ്"
      },
      "SUBMIT": "സമർപ്പിക്കുക",
      "CANCEL": "റദ്ദാക്കുക"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "എല്ലാ ഷോർട്ട്കട്ടുകളും കാണുക",
    "TITLE": {
      "OPEN_CONVERSATION": "സംഭാഷണം തുറക്കുക",
      "RESOLVE_AND_NEXT": "പരിഹരിച്ച് അടുത്തതിലേക്ക് നീങ്ങുക",
      "NAVIGATE_DROPDOWN": "ഡ്രോപ്പ്ഡൗൺ ഇനങ്ങളിൽ നാവിഗേറ്റ് ചെയ്യുക",
      "RESOLVE_CONVERSATION": "സംവാദം പരിഹരിക്കുക",
      "GO_TO_CONVERSATION_DASHBOARD": "സംവാദ ഡാഷ്ബോർഡിലേക്ക് പോകുക",
      "ADD_ATTACHMENT": "അറ്റാച്ച്മെന്റ് ചേർക്കുക",
      "GO_TO_CONTACTS_DASHBOARD": "Contacts ഡാഷ്ബോർഡിലേക്ക് പോകുക",
      "TOGGLE_SIDEBAR": "സൈഡ്ബാർ ടോഗിൾ ചെയ്യുക",
      "GO_TO_REPORTS_SIDEBAR": "റിപ്പോർട്ടുകൾ സൈഡ്ബാറിലേക്ക് പോകുക",
      "MOVE_TO_NEXT_TAB": "സംവാദ പട്ടികയിലെ അടുത്ത ടാബിലേക്ക് നീങ്ങുക",
      "GO_TO_SETTINGS": "സെറ്റിംഗ്സിലേക്ക് പോകുക",
      "SWITCH_TO_PRIVATE_NOTE": "സ്വകാര്യ കുറിപ്പിലേക്ക് മാറുക",
      "SWITCH_TO_REPLY": "പ്രതികരണത്തിലേക്ക് മാറുക",
      "TOGGLE_SNOOZE_DROPDOWN": "സ്നൂസ് ഡ്രോപ്പ്ഡൗൺ ടോഗിൾ ചെയ്യുക"
    }
  },
  "ASSIGNMENT_POLICY": {
    "INDEX": {
      "HEADER": {
        "TITLE": "ഏജന്റ് നിയോഗം",
        "DESCRIPTION": "ഇൻബോക്സുകളും ഏജന്റുമാരുടെയും ആവശ്യങ്ങൾ അടിസ്ഥാനമാക്കി ജോലി ഭാരം ഫലപ്രദമായി നിയന്ത്രിക്കുകയും സംഭാഷണങ്ങൾ റൂട്ടുചെയ്യുകയും ചെയ്യാൻ നയം നിർവചിക്കുക. കൂടുതൽ അറിയാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക"
      },
      "ASSIGNMENT_POLICY": {
        "TITLE": "നിയുക്തി നയം",
        "DESCRIPTION": "ഇൻബോക്സുകളിൽ സംഭാഷണങ്ങൾ എങ്ങനെ നിയുക്തമാക്കപ്പെടുന്നു എന്ന് നിയന്ത്രിക്കുക.",
        "FEATURES": [
          "സംഭാഷണങ്ങളുടെ അടിസ്ഥാനത്തിൽ സമമായി അല്ലെങ്കിൽ ലഭ്യമായ ശേഷിയനുസരിച്ച് നിയുക്തമാക്കുക",
          "ഏതെങ്കിലും ഏജന്റിനെ അധികഭാരം നൽകാതിരിക്കാൻ നീതിപൂർവ്വമായ വിതരണം നിയമങ്ങൾ ചേർക്കുക",
          "ഒരു നയത്തിലേക്ക് ഇൻബോക്സുകൾ ചേർക്കുക - ഓരോ ഇൻബോക്സിനും ഒരു നയം"
        ]
      },
      "AGENT_CAPACITY_POLICY": {
        "TITLE": "ഏജന്റ് ശേഷി നയം",
        "DESCRIPTION": "ഏജന്റുമാർക്ക് ജോലി ഭാരം നിയന്ത്രിക്കുക.",
        "FEATURES": [
          "ഇൻബോക്സിന് പരമാവധി സംഭാഷണങ്ങൾ നിർവചിക്കുക",
          "ലേബലുകളും സമയവും അടിസ്ഥാനമാക്കി വ്യത്യാസങ്ങൾ സൃഷ്ടിക്കുക",
          "ഒരു നയത്തിലേക്ക് ഏജന്റുമാർ ചേർക്കുക - ഓരോ ഏജന്റിനും ഒരു നയം"
        ]
      }
    },
    "AGENT_ASSIGNMENT_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "നിയുക്തി നയം",
          "CREATE_POLICY": "പുതിയ നയം"
        },
        "CARD": {
          "ORDER": "ക്രമം",
          "PRIORITY": "പ്രാധാന്യം",
          "ACTIVE": "സജീവമാണ്",
          "INACTIVE": "സജീവമല്ല",
          "POPOVER": "ചേർത്ത ഇൻബോക്സുകൾ",
          "EDIT": "എഡിറ്റുചെയ്യുക"
        },
        "NO_RECORDS_FOUND": "അസൈൻമെന്റ് നയങ്ങൾ കണ്ടെത്തിയില്ല"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "അസൈൻമെന്റ് നയം സൃഷ്ടിക്കുക"
        },
        "CREATE_BUTTON": "പോളിസി സൃഷ്ടിക്കുക",
        "API": {
          "SUCCESS_MESSAGE": "അസൈൻമെന്റ് പോളിസി വിജയകരമായി സൃഷ്ടിച്ചു",
          "ERROR_MESSAGE": "അസൈൻമെന്റ് പോളിസി സൃഷ്ടിക്കാൻ പരാജയപ്പെട്ടു",
          "INBOX_LINKED": "ഇൻബോക്സ് നയം ബന്ധിപ്പിച്ചു"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "അസൈൻമെന്റ് പോളിസി തിരുത്തുക"
        },
        "EDIT_BUTTON": "പോളിസി അപ്ഡേറ്റ് ചെയ്യുക",
        "CONFIRM_ADD_INBOX_DIALOG": {
          "TITLE": "ഇൻബോക്സ് ചേർക്കുക",
          "DESCRIPTION": "{inboxName} ഇൻബോക്സ് മറ്റൊരു നയവുമായി ഇതിനകം ബന്ധിപ്പിച്ചിരിക്കുന്നു. നിങ്ങൾക്ക് ഇത് ഈ നയവുമായി ബന്ധിപ്പിക്കാൻ ഉറപ്പാണോ? ഇത് മറ്റൊരു നയത്തിൽ നിന്ന് ബന്ധമൊഴിയിക്കും.",
          "CONFIRM_BUTTON_LABEL": "തുടരുക",
          "CANCEL_BUTTON_LABEL": "റദ്ദാക്കുക"
        },
        "INBOX_LINK_PROMPT": {
          "TITLE": "ഇൻബോക്സ് നയവുമായി ബന്ധിപ്പിക്കുക",
          "DESCRIPTION": "ഈ ഇൻബോക്സ് അസൈൻമെന്റ് നയവുമായി ബന്ധിപ്പിക്കണോ?",
          "LINK_BUTTON": "ഇൻബോക്സ് ബന്ധിപ്പിക്കുക",
          "CANCEL_BUTTON": "വിടുക"
        },
        "API": {
          "SUCCESS_MESSAGE": "അസൈൻമെന്റ് നയം വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",
          "ERROR_MESSAGE": "അസൈൻമെന്റ് നയം അപ്ഡേറ്റ് ചെയ്യാൻ പരാജയപ്പെട്ടു"
        },
        "INBOX_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "പോളിസിയിലേക്ക് ഇൻബോക്സ് വിജയകരമായി ചേർത്തു",
            "ERROR_MESSAGE": "പോളിസിയിലേക്ക് ഇൻബോക്സ് ചേർക്കാൻ പരാജയപ്പെട്ടു"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "പോളിസിയിൽ നിന്ന് ഇൻബോക്സ് വിജയകരമായി നീക്കം ചെയ്തു",
            "ERROR_MESSAGE": "പോളിസിയിൽ നിന്ന് ഇൻബോക്സ് നീക്കം ചെയ്യാൻ പരാജയപ്പെട്ടു"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "പോളിസി പേര്:",
          "PLACEHOLDER": "പോളിസി പേര് നൽകുക"
        },
        "DESCRIPTION": {
          "LABEL": "വിവരണം:",
          "PLACEHOLDER": "വിവരണം നൽകുക"
        },
        "STATUS": {
          "LABEL": "സ്ഥിതി:",
          "PLACEHOLDER": "സ്ഥിതി തിരഞ്ഞെടുക്കുക",
          "ACTIVE": "പോളിസി സജീവമാണ്",
          "INACTIVE": "പോളിസി സജീവമല്ല"
        },
        "ASSIGNMENT_ORDER": {
          "LABEL": "നിയോഗം ക്രമം",
          "ROUND_ROBIN": {
            "LABEL": "റൗണ്ട് റോബിൻ",
            "DESCRIPTION": "ഏജന്റുമാരിൽ സമമായി സംഭാഷണങ്ങൾ നിയോഗിക്കുക."
          },
          "BALANCED": {
            "LABEL": "സമതുലിതം",
            "DESCRIPTION": "ലഭ്യമായ ശേഷിയുടെ അടിസ്ഥാനത്തിൽ സംഭാഷണങ്ങൾ നിയോഗിക്കുക.",
            "PREMIUM_MESSAGE": "സമതുലിതമായ നിയോഗവും ഏജന്റ് ശേഷി മാനേജ്മെന്റും ലഭിക്കാൻ അപ്ഗ്രേഡ് ചെയ്യുക.",
            "PREMIUM_BADGE": "പ്രീമിയം"
          }
        },
        "ASSIGNMENT_PRIORITY": {
          "LABEL": "നിയോഗ മുൻഗണന",
          "EARLIEST_CREATED": {
            "LABEL": "ആദ്യമായി സൃഷ്ടിച്ചത്",
            "DESCRIPTION": "ആദ്യമായി സൃഷ്ടിച്ച സംഭാഷണം ആദ്യം നിയോഗിക്കപ്പെടും."
          },
          "LONGEST_WAITING": {
            "LABEL": "ഏറ്റവും നീണ്ട സമയം കാത്തിരിക്കുന്ന",
            "DESCRIPTION": "ഏറ്റവും നീണ്ട സമയം കാത്തിരിക്കുന്ന സംഭാഷണം ആദ്യം നിയോഗിക്കപ്പെടും."
          }
        },
        "FAIR_DISTRIBUTION": {
          "LABEL": "ന്യായമായ വിതരണം നയം",
          "DESCRIPTION": "ഏജന്റുമാരെ അധികം ഭാരമുള്ളതാക്കാതിരിക്കാൻ ഒരു സമയപരിധിയിൽ ഓരോ ഏജന്റിനും നിയോഗിക്കാവുന്ന പരമാവധി സംഭാഷണങ്ങളുടെ എണ്ണം സജ്ജമാക്കുക. ഈ ആവശ്യമായ ഫീൽഡ് ഡിഫോൾട്ടായി മണിക്കൂറിന് 100 സംഭാഷണങ്ങളാണ്.",
          "INPUT_MAX": "പരമാവധി നിയോഗിക്കുക",
          "DURATION": "ഓരോ ഏജന്റിനും ഓരോ"
        },
        "EXCLUDE_OLDER_THAN": {
          "LABEL": "Skip stale conversations",
          "DESCRIPTION": "Skip unassigned conversations older than this. Defaults to 7 days; clear to disable."
        },
        "INBOXES": {
          "LABEL": "ചേർത്ത ഇൻബോക്സുകൾ",
          "DESCRIPTION": "ഈ നയം ബാധകമാകുന്ന ഇൻബോക്സുകൾ ചേർക്കുക.",
          "ADD_BUTTON": "ഇൻബോക്സ് ചേർക്കുക",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "ചേർക്കാൻ ഇൻബോക്സുകൾ തിരയുകയും തിരഞ്ഞെടുക്കുകയും ചെയ്യുക",
            "ADD_BUTTON": "ചേർക്കുക"
          },
          "EMPTY_STATE": "ഈ നയത്തിലേക്ക് ഒരു ഇൻബോക്സ് ചേർത്തിട്ടില്ല, ആരംഭിക്കാൻ ഒരു ഇൻബോക്സ് ചേർക്കുക",
          "API": {
            "SUCCESS_MESSAGE": "നയത്തിലേക്ക് ഇൻബോക്സ് വിജയകരമായി ചേർത്തു",
            "ERROR_MESSAGE": "നയത്തിലേക്ക് ഇൻബോക്സ് ചേർക്കാൻ പരാജയപ്പെട്ടു"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "അസൈൻമെന്റ് നയം വിജയകരമായി മായ്ച്ചു",
        "ERROR_MESSAGE": "അസൈൻമെന്റ് നയം മായ്ക്കാൻ പരാജയപ്പെട്ടു"
      }
    },
    "AGENT_CAPACITY_POLICY": {
      "INDEX": {
        "HEADER": {
          "TITLE": "ഏജന്റ് ശേഷി",
          "CREATE_POLICY": "പുതിയ നയം"
        },
        "CARD": {
          "POPOVER": "ചേർത്ത ഏജന്റുമാർ",
          "EDIT": "എഡിറ്റുചെയ്യുക"
        },
        "NO_RECORDS_FOUND": "ഏജന്റ് ശേഷി നയങ്ങൾ കണ്ടെത്തിയില്ല"
      },
      "CREATE": {
        "HEADER": {
          "TITLE": "ഏജന്റ് ശേഷി നയം സൃഷ്ടിക്കുക"
        },
        "CREATE_BUTTON": "നയം സൃഷ്ടിക്കുക",
        "API": {
          "SUCCESS_MESSAGE": "ഏജന്റ് ശേഷി നയം വിജയകരമായി സൃഷ്ടിച്ചു",
          "ERROR_MESSAGE": "ഏജന്റ് ശേഷി നയം സൃഷ്ടിക്കാൻ പരാജയപ്പെട്ടു"
        }
      },
      "EDIT": {
        "HEADER": {
          "TITLE": "ഏജന്റ് ശേഷി നയം തിരുത്തുക"
        },
        "EDIT_BUTTON": "നയം അപ്ഡേറ്റ് ചെയ്യുക",
        "CONFIRM_ADD_AGENT_DIALOG": {
          "TITLE": "ഏജന്റ് ചേർക്കുക",
          "DESCRIPTION": "{agentName} ഇതിനകം മറ്റൊരു നയവുമായി ബന്ധിപ്പിച്ചിരിക്കുന്നു. നിങ്ങൾക്ക് ഇത് ഈ നയവുമായി ബന്ധിപ്പിക്കണമെന്ന് ഉറപ്പാണോ? ഇത് മറ്റൊരു നയത്തിൽ നിന്ന് ബന്ധമൊഴിയിക്കും.",
          "CONFIRM_BUTTON_LABEL": "തുടരുക",
          "CANCEL_BUTTON_LABEL": "റദ്ദാക്കുക"
        },
        "API": {
          "SUCCESS_MESSAGE": "ഏജന്റ് ശേഷി നയം വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",
          "ERROR_MESSAGE": "ഏജന്റ് ശേഷി നയം അപ്ഡേറ്റ് ചെയ്യാൻ പരാജയപ്പെട്ടു"
        },
        "AGENT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "നയത്തിലേക്ക് ഏജന്റ് വിജയകരമായി ചേർത്തു",
            "ERROR_MESSAGE": "നയത്തിലേക്ക് ഏജന്റ് ചേർക്കാൻ പരാജയപ്പെട്ടു"
          },
          "REMOVE": {
            "SUCCESS_MESSAGE": "നയത്തിൽ നിന്ന് ഏജന്റ് വിജയകരമായി നീക്കം ചെയ്തു",
            "ERROR_MESSAGE": "പോളിസിയിൽ നിന്ന് ഏജന്റ് നീക്കം ചെയ്യാൻ പരാജയപ്പെട്ടു"
          }
        },
        "INBOX_LIMIT_API": {
          "ADD": {
            "SUCCESS_MESSAGE": "ഇൻബോക്സ് പരിധി വിജയകരമായി ചേർത്തു",
            "ERROR_MESSAGE": "ഇൻബോക്സ് പരിധി ചേർക്കാൻ പരാജയപ്പെട്ടു"
          },
          "UPDATE": {
            "SUCCESS_MESSAGE": "ഇൻബോക്സ് പരിധി വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",
            "ERROR_MESSAGE": "ഇൻബോക്സ് പരിധി അപ്ഡേറ്റ് ചെയ്യാൻ പരാജയപ്പെട്ടു"
          },
          "DELETE": {
            "SUCCESS_MESSAGE": "ഇൻബോക്സ് പരിധി വിജയകരമായി ഇല്ലാതാക്കി",
            "ERROR_MESSAGE": "ഇൻബോക്സ് പരിധി ഇല്ലാതാക്കാൻ പരാജയപ്പെട്ടു"
          }
        }
      },
      "FORM": {
        "NAME": {
          "LABEL": "പോളിസി പേര്:",
          "PLACEHOLDER": "പോളിസി പേര് നൽകുക"
        },
        "DESCRIPTION": {
          "LABEL": "വിവരണം:",
          "PLACEHOLDER": "വിവരണം നൽകുക"
        },
        "INBOX_CAPACITY_LIMIT": {
          "LABEL": "ഇൻബോക്സ് ശേഷി പരിധികൾ",
          "ADD_BUTTON": "ഇൻബോക്സ് ചേർക്കുക",
          "FIELD": {
            "SELECT_INBOX": "ഇൻബോക്സ് തിരഞ്ഞെടുക്കുക",
            "MAX_CONVERSATIONS": "പരമാവധി സംഭാഷണങ്ങൾ",
            "SET_LIMIT": "പരിധി നിശ്ചയിക്കുക"
          },
          "EMPTY_STATE": "ഇൻബോക്സ് പരിധി സജ്ജമാക്കിയിട്ടില്ല"
        },
        "EXCLUSION_RULES": {
          "LABEL": "വിലക്കൽ നിയമങ്ങൾ",
          "DESCRIPTION": "താഴെ പറയുന്ന നിബന്ധനകൾ പാലിക്കുന്ന സംഭാഷണങ്ങൾ ഏജന്റ് ശേഷിയിൽ ഉൾപ്പെടില്ല",
          "TAGS": {
            "LABEL": "നിശ്ചിത ലേബലുകൾ അടങ്ങിയ സംഭാഷണങ്ങൾ ഒഴിവാക്കുക",
            "ADD_TAG": "ലേബൽ ചേർക്കുക",
            "DROPDOWN": {
              "SEARCH_PLACEHOLDER": "തിരയുകയും ചേർക്കാൻ ടാഗുകൾ തിരഞ്ഞെടുക്കുകയും ചെയ്യുക"
            },
            "EMPTY_STATE": "ഈ നയത്തിൽ ടാഗുകൾ ചേർത്തിട്ടില്ല."
          },
          "DURATION": {
            "LABEL": "നിശ്ചിത ദൈർഘ്യമേൽപ്പിച്ച പഴക്കമുള്ള സംഭാഷണങ്ങൾ ഒഴിവാക്കുക",
            "PLACEHOLDER": "സമയം സജ്ജമാക്കുക"
          }
        },
        "USERS": {
          "LABEL": "നിയുക്തമാക്കിയ ഏജന്റുമാർ",
          "DESCRIPTION": "ഈ നയം ബാധകമാകുന്ന ഏജന്റുകളെ ചേർക്കുക.",
          "ADD_BUTTON": "ഏജന്റ് ചേർക്കുക",
          "DROPDOWN": {
            "SEARCH_PLACEHOLDER": "ചേർക്കാൻ ഏജന്റുകളെ തിരയുകയും തിരഞ്ഞെടുക്കുകയും ചെയ്യുക",
            "ADD_BUTTON": "ചേർക്കുക"
          },
          "EMPTY_STATE": "ഏജന്റുമാരില്ല",
          "API": {
            "SUCCESS_MESSAGE": "ഏജന്റ് നയത്തിലേക്ക് വിജയകരമായി ചേർത്തു",
            "ERROR_MESSAGE": "പോളിസിലേക്ക് ഏജന്റ് ചേർക്കാൻ പരാജയപ്പെട്ടു"
          }
        }
      },
      "DELETE_POLICY": {
        "SUCCESS_MESSAGE": "ഏജന്റ് ശേഷി നയം വിജയകരമായി മായ്ചു",
        "ERROR_MESSAGE": "ഏജന്റ് ശേഷി നയം മായ്ക്കാൻ പരാജയപ്പെട്ടു"
      }
    },
    "DELETE_POLICY": {
      "TITLE": "നയം മായ്ക്കുക",
      "DESCRIPTION": "നിങ്ങൾക്ക് ഈ നയം ഇല്ലാതാക്കാൻ ഉറപ്പാണോ? ഈ പ്രവർത്തനം തിരുത്താനാകില്ല.",
      "CONFIRM_BUTTON_LABEL": "ഇല്ലാതാക്കുക",
      "CANCEL_BUTTON_LABEL": "റദ്ദാക്കുക"
    }
  }
}
